// extracted by mini-css-extract-plugin
export default {"container":"ik-z","freeShip":"jk-z","privacy":"kk-z"};